import { addOfferRequest } from '../../../services/network/common/offer';

class CommonOfferService {
    async addOffer(values) {
        return await addOfferRequest(values);
    }
}

export const OfferService = new CommonOfferService();
